import React from "react";
import FormControl from "@mui/material/FormControl";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import { styled } from "@mui/material/styles";
import Noindex from "../Noindex";

const CustomInput = styled(Input)({
  "&.MuiInput-root": {
    margin: 0,
  },
  "& .MuiInputBase-input": {
    borderRadius: 5,
    position: "relative",
    border: "1px solid #ced4da",
    padding: "10px 12px",
  },
});

const CustomInputLabel = styled(InputLabel)({
  position: "relative",
  transform: "none",
  marginBottom: "5px",
});

export default function CustomInputComponent() {
  return (
    <>
      <Noindex />
      <FormControl variant="standard">
        <CustomInputLabel htmlFor="custom-input">Email</CustomInputLabel>
        <CustomInput id="custom-input" disableUnderline />
      </FormControl>
    </>
  );
}
